import { Container } from '@mui/system';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Navigation from './components/Navigation/Navigation';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import { AppInit } from './redux/actions';
import { useAppDispatch, useAppSelector } from './redux/hooks';
import { NavigationUtil } from './utils/NavigationUtil';




const AppRouter = () => {
  const dispatch = useAppDispatch()
  const session_data = useAppSelector(state => state.session_data)

  const loggedIn = session_data ? true : false;

  React.useEffect(()=> {
    dispatch(AppInit())

  }, [dispatch])

  return (
    <BrowserRouter>
      <NavigationUtil/>
      {loggedIn ? 
        <Navigation/>
        :
        <Navigation
          hasUser={loggedIn}
        />
      }
      <Container
        maxWidth={'lg'}
      >
        <Routes>
          {loggedIn ? 
            <>
              <Route path="/" element={<Dashboard/>}/>
            </>
          :
            <>
              <Route path="/" element={<Login/>}/>
              <Route path="/login" element={<Login/>}/>
            </>

          }
          
          <Route path="*" element={<NotFound/>}/>
        </Routes>
      </Container>
    </BrowserRouter>
  );
}

export default AppRouter;
